import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IncomingCallService {
  public incomingCallSubject: any;
  public outgoingCallRejectEventSubject: any;
  constructor() {
    this.incomingCallSubject = new BehaviorSubject(null);
    this.outgoingCallRejectEventSubject = new BehaviorSubject(null);
  }
}
